"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

require("leaflet/dist/leaflet.css");

require("./Style.css");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _leaflet = require("leaflet");

var _leaflet2 = _interopRequireDefault(_leaflet);

var _reactLeaflet = require("react-leaflet");

var _logo = require("@identitybuilding/idb-react-ui-elements/dist/placeholders/png/logo.png");

var _logo2 = _interopRequireDefault(_logo);

var _rgbaster = require("rgbaster");

var _rgbaster2 = _interopRequireDefault(_rgbaster);

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapMarker = function (_Component) {
	(0, _inherits3.default)(MapMarker, _Component);

	function MapMarker(props) {
		(0, _classCallCheck3.default)(this, MapMarker);

		var _this = (0, _possibleConstructorReturn3.default)(this, (MapMarker.__proto__ || (0, _getPrototypeOf2.default)(MapMarker)).call(this, props));

		_this.state = {
			zoomedMarker: false,
			zoomId: '',
			addresses: [],
			loadedColors: false,
			markerChange: false
		};
		return _this;
	}

	(0, _createClass3.default)(MapMarker, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			this.map = this.mapInstance.leafletElement;
			this.props.page !== 'bp' && this.props.getMap(this.map);
			setTimeout(function () {
				_this2.props.page === 'bp' && _this2.map.panTo([_this2.props.addresses[0].data.address.lat, _this2.props.addresses[0].data.address.long]);
			}, 1000);

			// this.getColors()
		}

		// async getColors() {
		// 	this.setState({ loadedColors: false })
		// 	const copy = [...this.props.addresses]
		// 	for (let i = 0; i < copy.length; i++) {
		// 		if (copy[i].data.logos.length > 0) {
		// 			const result = await analyze(copy[i].data.logos[0].logo, { ignore: ['rgb(255,255,255)', 'rgb(254,254,254)', 'rgb(253,253,253)', 'rgb(252,252,252)', 'rgb(251,251,251)', 'rgb(0,0,0)'] })
		// 			copy[i].data.logos[0].color = result[0].color
		// 			this.setState({ addresses: copy })
		// 		}
		// 	}
		// 	this.setState({ loadedColors: true })
		// }

	}, {
		key: "handleClick",
		value: function handleClick(address, i, e) {
			var _state = this.state,
			    zoomId = _state.zoomId,
			    zoomedMarker = _state.zoomedMarker;
			var _props = this.props,
			    zoomed = _props.zoomed,
			    zoomLvl = _props.zoomLvl;

			if (this.props.page === 'brands') {
				this.props.setZoomed(address.data.vat);
			} else if (zoomed) {
				var allMarkers = document.querySelectorAll('.leaflet-marker-icon');
				for (var _i = 0; _i < allMarkers.length; _i++) {
					allMarkers[_i].classList.remove('active');
					allMarkers[_i].classList.remove('click');
				}
				if (zoomId !== address.data.id) {
					// When zoomed in, and clicked on another marker, this will simply let you go to the other marker
					this.map.setView([address.data.address.lat, address.data.address.long], zoomLvl ? zoomLvl : 16);
					this.props.scrollTo(address.data.id);
					e.target._icon.classList.add('active');
					e.target._icon.classList.add('click');
					// this.props.setZoomed(false)
				} else {
					// This will rerender the map and go to it original bounds.
					this.setState({ state: this.state });
					this.props.setZoomed(false);
					e.target._icon.classList.remove('active');
					e.target._icon.classList.remove('click');
				}
			} else {
				// Set the view to chosen long/lat and zoom
				// change the state without this.setState, because we don't want the map to rerender and go to it's original bounds
				this.map.setView([address.data.address.lat, address.data.address.long], zoomLvl ? zoomLvl : 16);
				this.props.scrollTo(address.data.id);
				this.props.setZoomed(!zoomedMarker);
				e.target._icon.classList.add('active');
				e.target._icon.classList.add('click');
			}

			// change the state without this.setState, because we don't want the map to rerender and go to it's original bounds
			this.state.zoomId = address.data.id;
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var page = this.props.page;


			return _react2.default.createElement(
				_react.Fragment,
				null,
				this.props.page === "change_marker" && _react2.default.createElement(
					"div",
					{
						onClick: function onClick() {
							return _this3.setState({ markerChange: !_this3.state.markerChange });
						},
						className: "addMarker " + (this.state.markerChange ? 'active' : '')
					},
					_react2.default.createElement(_idbReactIconlib2.default, { name: "Mapmarker" })
				),
				_react2.default.createElement(
					_reactLeaflet.Map,
					{
						ref: function ref(e) {
							_this3.mapInstance = e;
						},
						id: "map",
						bounds: this.props.bounds,
						boundsOptions: { padding: [50, 50] },
						zoomControl: false,
						minZoom: page === 'bp' && 13,
						dragging: !_leaflet2.default.Browser.mobile,
						touchZoom: true,
						onclick: function onclick(e) {
							return _this3.props.page === "change_marker" && _this3.state.markerChange ? (_this3.props.changeLngLat(e), _this3.setState({ markerChange: false })) : "";
						},
						className: "MyMap " + (this.state.markerChange && "active")
					},
					_react2.default.createElement(_reactLeaflet.TileLayer, {
						attribution: "&copy <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
						url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					}),
					_react2.default.createElement(_reactLeaflet.ZoomControl, { position: "bottomright" }),
					this.props.addresses.map(function (address, index) {
						// Extract the marker URL, fallback to a placeholder if not available
						var markerIconUrl = address.data.markers && address.data.markers[0] && address.data.markers[0].marker ? address.data.markers[0].marker : address.data.logos && address.data.logos[0] && address.data.logos[0].logo ? address.data.logos[0].logo : _logo2.default;

						return _react2.default.createElement(
							_reactLeaflet.Pane,
							{
								style: { zIndex: 1000 - index },
								className: "markerOsn marker_" + address.data.id,
								key: index
							},
							_react2.default.createElement(_reactLeaflet.Marker, {
								map: _this3.map,
								onclick: function onclick(e) {
									page !== 'bp' && _this3.handleClick(address, _this3.props.bounds, e);
								},
								position: [address.data.address.lat, address.data.address.long],
								icon: _leaflet2.default.divIcon({
									html: "\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"markerShape\" style=\"border: 1px solid " + (address.data.logos.length > 0 && address.data.logos[0].color ? address.data.logos[0].color : 'var(--main)') + "\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"markerLogo\" style=\"background-color: white; \n\t\t\t\t\t\t\t\t\t\t\t\t\tbackground-image: url(" + markerIconUrl + ");\"\n\t\t\t\t\t\t\t\t\t\t\t\t></span>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class='markerTriangle' style=\"border-top: 10px solid " + (address.data.logos.length > 0 && address.data.logos[0].color ? address.data.logos[0].color : 'var(--main)') + "\"></div>\n\t\t\t\t\t\t\t\t\t\t\t</span>",
									iconAnchor: [25, 60],
									iconSize: [50, 50],
									className: "markerOsn marker_" + address.data.id
								}),
								onmouseover: function onmouseover(e) {
									return page !== 'bp' && e.target._icon.classList.add('active');
								},
								onmouseout: function onmouseout(e) {
									page !== 'bp' && !e.target._icon.classList.contains('click') && e.target._icon.classList.remove('active');
								}
							})
						);
					})
				)
			);
		}
	}]);
	return MapMarker;
}(_react.Component);
// import MarkerClusterGroup from 'react-leaflet-markercluster';


exports.default = MapMarker;